// eslint-disable-next-line import/prefer-default-export
export const BET_HISTORY_PAGE_LENGTH = 25;
export const BET_HISTORY_MAX_PAGES_COUNT = 1;
export const BET_HISTORY_MAX_REQUEST_LENGTH =
    (BET_HISTORY_MAX_PAGES_COUNT * BET_HISTORY_PAGE_LENGTH) + 1;
export const BET_HISTORY_REDIRECT_CONFIG = {
    paddypower: {
        text: 'To view full bet history visit',
        link: 'www.paddypower.com',
    },
    betfair: {
        text: 'To view full bet history visit',
        link: 'www.betfair.com',
    },
    williamhill: {
        text: 'To view full bet history visit',
        link: 'www.williamhill.com',
    },
    bet365: {
        text: 'To view full bet history visit',
        link: 'www.bet365.com',
    },
    ladbrokes: {
        text: 'To view full bet history visit',
        link: 'www.ladbrokes.com',
    },
    coral: {
        text: 'To view full bet history visit',
        link: 'www.coral.co.uk',
    },
};




// WEBPACK FOOTER //
// /src/js/BetHistory/components/betHistory.constants.js